import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAxios } from '../core/_axios';
import useAccount from '../hooks/useAccount';
import MobileAccountSwitcher from './MobileAccountSwitcher';

const MobileHeader: React.FC = () => {
  const { currentUser, viewingAllAccounts } = useAuth();
  const [showAccountSwitcher, setShowAccountSwitcher] = useState(false);
  const axios = useAxios();
  
  // Get current account information when not viewing all accounts
  const { account: currentAccount } = useAccount({
    axios,
    isForCurrentAccount: !viewingAllAccounts
  });

  const toggleMobileMenu = () => {
    const drawer = document.getElementById('mobile-menu-drawer');
    if (drawer) {
      drawer.classList.toggle('show');
    }
  };

  // Helper function to get display text for account button
  const getAccountDisplayText = () => {
    if (viewingAllAccounts) return 'All Accounts';
    if (currentAccount?.name) {
      // Show account name if 20 characters or less, otherwise show "Switch"
      return currentAccount.name.length <= 20 ? currentAccount.name : 'Switch';
    }
    return 'Switch';
  };

  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 bg-white dark:bg-coal-600 border-b border-gray-200 dark:border-coal-100 z-40 h-14">
      <div className="flex items-center justify-between h-full px-4">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            className="h-8 dark:hidden"
            src="/design/web_logo_signature_guestbook_black.png"
            alt="Signature Guestbook"
          />
          <img
            className="h-8 hidden dark:block"
            src="/design/web_logo_signature_guestbook_white.png"
            alt="Signature Guestbook"
          />
        </Link>

        {/* Right side actions */}
        <div className="flex items-center gap-2">
          {/* Account indicator - now clickable with smart text */}
          <button
            onClick={() => setShowAccountSwitcher(true)}
            className={`text-xs px-2 py-1 rounded hover:opacity-80 transition-colors max-w-24 truncate ${
              viewingAllAccounts 
                ? 'bg-primary/10 text-primary hover:bg-primary/20' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            title={currentAccount?.name || (viewingAllAccounts ? 'All Accounts' : 'Switch Account')}
          >
            {getAccountDisplayText()}
          </button>

          {/* Hamburger menu */}
          <button
            onClick={toggleMobileMenu}
            className="p-2 hover:bg-gray-100 dark:hover:bg-coal-500 rounded-lg transition-colors"
          >
            <i className="ki-filled ki-menu text-xl text-gray-700 dark:text-gray-200"></i>
          </button>
        </div>
      </div>
      
      {/* Mobile Account Switcher Modal */}
      <MobileAccountSwitcher 
        isOpen={showAccountSwitcher}
        onClose={() => setShowAccountSwitcher(false)}
      />
    </header>
  );
};

export default MobileHeader;